define([
    'text!index2021-base-line/component/swiper-title.html',
    // 'common/api',
    'jquery',
    '../common/utils',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!index2021-base-line/component/swiper-title.css'

], function(
    tpl,
    // Api,
    $,Utils,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {

            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwiperImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String,
            ISPC: Boolean
        },
        methods: {
            init: function () {
                if(this.SwiperType=='base'){
                    new Swiper('#swiper-base',{
                        observer: true,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        }
                    });
                }
            }
        },
        watch: {
            SwiperType: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-base-line/component/swiper-title.js
// module id = 131
// module chunks = 10 11